import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

export default function useRecommendationWidgetViewed({carouselType, hasAds}) {
  const {domain, i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {ADS_DETAIL_PAGE_TYPE, TRACKING_DATA_BY_PAGE, TRACKING_EVENT_NAMES, TRACKING_TRANSLATIONS_BY_CULTURE} =
    config.get('tracking')
  const {ADS_DETAIL_PAGE_NAME: pageNameOrigin} = TRACKING_TRANSLATIONS_BY_CULTURE[i18n.culture]

  useMount(() => {
    if (!hasAds) return

    track({
      event: TRACKING_EVENT_NAMES.RECOMMENDATION_WIDGET_VIEWED,
      data: {
        carousel_type: carouselType,
        channel: TRACKING_DATA_BY_PAGE.ADS_DETAIL.channel,
        page_type: ADS_DETAIL_PAGE_TYPE,
        page_name_origin: pageNameOrigin
      }
    })
  })
}
